import _ from "lodash";

const useProductReport = () => {

  const execute = (catalogs: any, receipts: any) => {
    const receiptsHolder: Record<string, { name: string, amount: number, quantity: number }> = _.reduce(receipts, (acc, receipt) => {
      _.forEach(receipt.OrderItems, (item) => {
        if (acc[item.subItemId]) {
          acc[item.subItemId].amount += item.discountedPrice;
          acc[item.subItemId].quantity += item.quantity;
        } else {
          acc[item.subItemId] = { name: item.name, amount: item.discountedPrice, quantity: item.quantity };
        }
      });
      return acc;
    }, {});

    console.log("receiptsHolder=>", receiptsHolder)

    const catalogMapped = catalogs.map((catalog) => {
      return {
        ...catalog,
        Items: catalog.Items.map((item) => {
          return {
            ...item,
            SubItems: item.SubItems.filter((subItem) => receiptsHolder[subItem.Id]).map((subItem) => {
              return {
                ...subItem,
                Name: subItem.Name,
                amount: receiptsHolder[subItem.Id]?.amount || 0,
                quantity: receiptsHolder[subItem.Id]?.quantity || 0
              };
            })
          };
        })
      };
    });

    return catalogMapped;
  }

  //Mapping  product summary from api 
  const catalogMapping = (catalogs: any, receiptItemsHolder: any)=>{
    const _receiptItemsHolder = {...receiptItemsHolder}
    return catalogs.map((catalog) => {
      return {
        ...catalog,
        Items: catalog.Items.map((item) => {
          return {
            ...item,
            SubItems: item.SubItems.filter((subItem) => _receiptItemsHolder[subItem.Id]).map((subItem) => {
              return {
                ...subItem,
                Name: subItem.Name,
                amount: _receiptItemsHolder[subItem.Id]?.amount || 0,
                quantity: _receiptItemsHolder[subItem.Id]?.quantity || 0
              };
            })
          };
        })
      };
    });
  }

  const sumProductByType = (productDataExuted:any)=>{
    const productTypes = {}
      for(let catelog of productDataExuted){
        const key = catelog.Type || "Unknown"      
        if(productTypes[key] == undefined){
          productTypes[key] = {name:catelog.Type, total:0, groupByType:[]}
        }

        for(let item of catelog?.Items){
          for(let subItem of item?.SubItems){
            productTypes[key].total += subItem.amount
            productTypes[key].groupByType.push(catelog)
          }
        }   
      }

     

      const sumProductWithCategory = Object.values(productTypes).map((item: any) => {
        return {
          ...item,
          groupByType: _.uniqBy(item.groupByType, (catalog: any) => catalog?.Id ?? catalog?.id)
        }
      })
       console.log("sumProductWithCategory=>", sumProductWithCategory)
      return sumProductWithCategory
  }


  // param from function sumProductByType [{name:"", total:0, groupByType:[]}]
  const calcPercentProductTypeAndSort = (data:any) => {
    // รวมยอด total ทั้งหมด
    const totalSum = data.reduce(
      (sum:any, item:any) => sum + (Number(item.total) || 0),
      0
    );

    // กันหาร 0
    const base = totalSum === 0 ? 1 : totalSum;

    const FIXED_TYPE_ORDER = ['food', 'drink', 'dessert', 'other'];
    const orderIndex = (name: any) => {
      const idx = FIXED_TYPE_ORDER.indexOf(String(name || '').toLowerCase());
      return idx === -1 ? FIXED_TYPE_ORDER.length : idx;
    };

    return data
      .map((item: any) => {
        const total = Number(item.total) || 0;
        const percent = +(total / base * 100).toFixed(2);

        return {
          name: item.name,
          total,
          percent,
          groupByType: item.groupByType
        };
      })
      .sort((a: any, b: any) => {
        const diff = orderIndex(a.name) - orderIndex(b.name);
        if (diff !== 0) return diff;
        // types ที่ไม่อยู่ใน FIXED list: เรียง alphabetical กันสลับ
        return String(a.name).localeCompare(String(b.name));
      });
  }

  return {
    execute,
    catalogMapping,
    sumProductByType,
    calcPercentProductTypeAndSort
  };
}

export { useProductReport };
